/* eslint-disable */

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

// fetch the invoice details, and then redirect to the Stripe checkout page
export const makeStripePayment = async (
  invoiceid,
  token,
  userid,
  redirectUrl = null
) => {
  if (!invoiceid) {
    return;
  }

  try {
    const invoiceResponseGetRequestUrl =
      url.API_BASE_URL +
      url.API_GET_INVOICE_DETAILS +
      `/${invoiceid}`;

    const invoiceGetResponse = await getData(invoiceResponseGetRequestUrl);

    // console.log("make payment");

    let successUrl = url.FRONTEND_BASE_URL + "/payment/success";
    let failureUrl = url.FRONTEND_BASE_URL + "/payment/failure";

    if (invoiceid) {
      successUrl = successUrl + `?ref=${invoiceid}`;
    }

    if (redirectUrl) {
      successUrl = successUrl + `&redirectUrl=${redirectUrl}`;
    }

    let requestUrl =
      url.API_BASE_URL + url.API_CART_CHECKOUT_SESSION + ``;

    const paymentInfo = {
      cartItems: invoiceGetResponse.data.stripecartitems,
      userId: userid,
      invoiceid: invoiceid,
      successurl: successUrl,
      failureurl: failureUrl,
    };

    const response = await postData(requestUrl, paymentInfo);

    console.log("response", response);

    if (response.url) {
      // Modern approach: redirect directly to the checkout URL
      window.location.href = response.url;
    } else if (response.id) {
      // Fallback: construct the URL manually if only ID is returned
      console.warn("Checkout session URL not provided, this may not work correctly");
      window.location.href = `https://checkout.stripe.com/c/pay/${response.id}`;
    } else {
      // No valid redirect URL or session ID
      console.error("Payment session creation failed - no URL or ID returned");
      throw new Error("Unable to create payment session. Please try again.");
    }
  } catch (error) {
    console.log("Error", error.message);
    throw error; // Re-throw so calling code can handle it
  }
};
